import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=11f16dc2&scoped=true"
import script from "./LoadingDots.vue?vue&type=script&lang=js"
export * from "./LoadingDots.vue?vue&type=script&lang=js"
import style0 from "./LoadingDots.vue?vue&type=style&index=0&id=11f16dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f16dc2",
  null
  
)

export default component.exports